module.exports = __webpack_public_path__ + "img/bg-img.a085ac78.jpeg";